import { ChangeEvent, useCallback } from 'react';
import locale from '@glu/locale';
import { Input } from '@glu/form-components';
import { IFilterable, IFilterProps, IStringFilter } from '../Filters/Filters';

export interface IFuzzyFilterProps extends IFilterProps {
  /** The current value of the filter. Since state is not managed
   * locally this is required to display any current filter values.
   */
  value?: IStringFilter;
}

export const defaultParseFuzzyFilterValue = ({
  event,
  filterable,
}: {
  filterable: IFilterable;
  event: ChangeEvent<HTMLInputElement>;
}) => ({ filterable, value: { filter: event.target.value, type: 'contains' } });

const FuzzyFilter = ({ filterable, onChange, value }: IFuzzyFilterProps) => {
  const { field, filterOptions, headerName } = filterable;
  const { filter = '' } = value || {};
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      event.preventDefault();
      const changeValue = (filterOptions?.parseFilterValue || defaultParseFuzzyFilterValue)({
        filterable,
        event,
      });
      onChange(changeValue);
    },
    [filterOptions, filterable, onChange]
  );

  return (
    <Input
      disableInputAPI
      labelText={`${headerName} ${locale.get('dataComponents.filter')}`}
      name={field}
      onChange={handleChange}
      screenReaderLabel
      type="text"
      value={filter}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...filterOptions?.componentProps}
    />
  );
};

export default FuzzyFilter;
